import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Grow from "@mui/material/Grow";
import { useSelector, useDispatch } from "react-redux";
import {
  selectNotifications,
  selectShowNetworkErrorMessage,
} from "../ducks/notifications/selectors";
import {
  dismissNotification,
  hideNetworkErrorMessage,
} from "../ducks/notifications";
import { useTranslation } from "react-i18next";

const NetworkErrors = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["notifications"]);
  const showNetworkErrors = useSelector(selectShowNetworkErrorMessage);
  if (!showNetworkErrors) return null;
  return (
    <Grow in appear>
      <Alert
        severity="warning"
        onClose={() => {
          dispatch(hideNetworkErrorMessage());
        }}
      >
        {t("notifications:networkError")}
      </Alert>
    </Grow>
  );
};

// All toasts share one fixed column, so several at once stack instead of
// rendering on top of each other (one MUI Snackbar each would overlap).
const Notifications = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(selectNotifications);
  const closeNotification = (id: string) => dispatch(dismissNotification(id));
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        position: "fixed",
        zIndex: (theme) => theme.zIndex.snackbar,
        left: { xs: 8, sm: 24 },
        right: { xs: 8, sm: "auto" },
        bottom: { xs: 8, sm: 24 },
        display: "flex",
        flexDirection: "column",
        alignItems: { xs: "stretch", sm: "flex-start" },
        gap: 1,
        // Only the toasts themselves take clicks, not the empty column
        pointerEvents: "none",
        "& > *": { pointerEvents: "auto" },
      }}
    >
      {notifications.map((n) => (
        <Grow in appear key={n.id}>
          <Alert
            severity={n.type}
            variant="filled"
            onClose={() => closeNotification(n.id)}
          >
            {n.message || t(n.key as any, { ns: n.namespace as any })}
          </Alert>
        </Grow>
      ))}
      <NetworkErrors />
    </Box>
  );
};

export default Notifications;
